import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import backgroundActions from './redux/BackgroundMessages.actions';
import {FormattedMessage, injectIntl} from 'react-intl';
import {BACKGROUND_MESSAGE_TYPE} from "../../constants";
import PropTypes from "prop-types";

export class BackgroundMessage extends React.Component {

    state = {
        shrinkMessage: false
    };

    static propTypes = {
        clearBackgroundMessages: PropTypes.func,
        backgroundMessages: PropTypes.object
    };

    static defaultProps = {
        backgroundMessages: {
            title: null,
            message: null,
            messageParameters: '',
            icon: '',
            type: '',
            isVisible: false,
            shrink: false,
            close: false,
            link: null
        }
    };

    download = (e, downloadURL) => {
        window.open(downloadURL, '_self');
        this.props.clearBackgroundMessages();
    };

    shrinkMessage = () => {
        this.setState({shrinkMessage: true});
    };

    expandMessage = e => {
        if (e.target.classList.contains("background-message-icon") && this.state.shrinkMessage) {
            this.setState({shrinkMessage: false});
        }
    };

    render() {
        let {title, link, type, message, isVisible, icon, shrink, close, messageParameters} = this.props.backgroundMessages;

        let hasActionItems = close || shrink || (type === BACKGROUND_MESSAGE_TYPE.DOWNLOAD && link),
            shrinkClass = this.state.shrinkMessage && shrink ? "shrink" : "",
            typeClass = type ? "message-type-" + type : "";

        return (
            isVisible ?
                <div className={`background-message-wrapper ${shrinkClass} ${typeClass}`}
                     onClick={this.expandMessage}>
                    {
                        type !== BACKGROUND_MESSAGE_TYPE.DOWNLOAD
                        && <div className={icon && ("background-message-icon " + icon)}/>
                    }
                    <div className={"background-message-content"}>
                        <div className="background-message-box">
                            {
                                title
                                && <div className="background-message-title">
                                    {
                                        type === BACKGROUND_MESSAGE_TYPE.DOWNLOAD
                                        && <div className={icon && ("background-message-icon " + icon)}/>
                                    }
                                    <FormattedMessage id={title}/>
                                </div>
                            }
                            {
                                link
                                && <div>
                                    {
                                        type === BACKGROUND_MESSAGE_TYPE.DOWNLOAD
                                            ? <button id="download-button-message"
                                                      className="background-message-button-for-download"
                                                      onClick={e => {
                                                          this.download(e, link)
                                                      }}>
                                                {messageParameters}
                                            </button>
                                            : <a className="background-message-link-for-download"
                                                 href={link}>
                                                <div className="background-message-body">
                                                    {
                                                        message
                                                        && <FormattedMessage id={message}
                                                                             values={{term: messageParameters}}/>
                                                    }
                                                </div>
                                            </a>
                                    }
                                </div>
                            }
                            {
                                message
                                && <div className="background-message-body">
                                    <FormattedMessage id={message} values={{term: messageParameters}}/>
                                </div>
                            }
                        </div>
                        {
                            hasActionItems
                            && <div className="background-message-buttons-container">
                                {close
                                && <div className={"la-CloseRemove"}
                                        onClick={this.props.clearBackgroundMessages}/>
                                }
                                {type === BACKGROUND_MESSAGE_TYPE.DOWNLOAD && link
                                && <button id="download-button-icon"
                                           className={"la-Download"}
                                           onClick={e => {
                                               this.download(e, link)
                                           }}/>
                                }
                                {shrink
                                && <div className={"la-MinimizeRight"}
                                        onClick={this.shrinkMessage}/>
                                }
                            </div>
                        }
                    </div>
                </div>
                : null
        );
    }
}

const mapStateToProps = (state) => {
    return {
        backgroundMessages: state.backgroundMessages
    }
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        clearBackgroundMessages: backgroundActions.clearBackgroundMessages,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BackgroundMessage));



// WEBPACK FOOTER //
// ./src/scripts/reusable/BackgroundMessage/BackgroundMessage.index.jsx